import { WebPortalService } from '../resource'

const CorporateModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    createData ({ commit, state }, data) {
        return WebPortalService.CorpCreateV4(data)
    },
    updateData ({ commit, state }, data) {
        return WebPortalService.CorpRenameV4(data)
    },
    deleteData ({ commit, state }, data) {
        return WebPortalService.CorpDeleteV4(data)
    },
    async listData ({ commit, state }) {
      try{
        const data = await WebPortalService.CorpListV4()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    },
    getDataWithDefault (state) {
      return [{Brn:"",Code:"0",ID:0,Name:"-",UpperID:0,UpperName:""},...state.data]
    },
    getDataWithAll (state) {
      return [{Brn:"",Code:"0",ID:0,Name:"All",UpperID:0,UpperName:""},...state.data]
    }
  }
}

export default CorporateModule